import React from 'react';
import DashboardContainer from '../containers/DashboardContainer';
import PageLayout from '../components/Layout/PageLayout';

const DashboardPage = (props) => {
  return (
    <PageLayout>
      <DashboardContainer />
    </PageLayout>
  );
};

export default DashboardPage;